export default (username) => {
  if (!username) {
    return '';
  }

  return `@${username}`;
};
